import React from 'react';

import Textfield from '@atlaskit/textfield';

import { FilterStyled, SubtitleStyled } from './ProjectSettingsHeader.styled';
import { ProjectSettingsHeaderViewProps } from './ProjectSettingsHeader.types';

export const ProjectSettingsHeaderView: React.FC<ProjectSettingsHeaderViewProps> =
  ({
    title,
    subtitle,
    linkName,
    linkUrl,
    query,
    elementAfter,
    onFilterChange,
  }: ProjectSettingsHeaderViewProps) => {
    return (
      <>
        <div>
          <h3>{title}</h3>
        </div>
        <SubtitleStyled>
          {subtitle}&nbsp;
          <a href={linkUrl} target='_blank' rel='noreferrer'>
            {linkName}
          </a>
        </SubtitleStyled>
        <FilterStyled>
          <Textfield
            value={query}
            elemAfterInput={elementAfter}
            onChange={onFilterChange}
            placeholder='Search for project'
          />
        </FilterStyled>
      </>
    );
  };
